import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getSso } from '../requests';
import type { GetSsoRequestType } from '../types';

export const useGetSso = (
  { headers, pathParams: { ssoDriver }, queryParams }: GetSsoRequestType,
  options?: {
    enabled?: boolean;
    onSuccess?: (redirectTo: string) => void;
    onError?: (error: unknown) => void;
  },
) =>
  useQuery({
    // email is part of the key so that two different identifiers can never share
    // the cached single-use redirect URL produced for an earlier user.
    queryKey: [API_QUERY_KEYS.sso, { ssoDriver, email: queryParams?.email }],
    queryFn: () => getSso({ headers, pathParams: { ssoDriver }, queryParams }),
    ...options,
  });
